export default __webpack_public_path__ + "static/media/BrookshireBrothers_SingleLine_WithWhiteOutline.a6cd6f9d.png";